import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import { loginUser, logoutUser } from '@/api/auth';
import { constantUserType } from '@/utils/constant';

const store = new Vuex.Store({
  state: {
    user_id: '',
    token: '',
    user_type: '',
    advertiser_type: '',
  },
  getters: {
    isLogin(state) {
      return state.user_id !== '';
    },
    isOwner(state) {
      return state.user_type === constantUserType.Owner;
    },
    isAdmin(state) {
      return state.user_type === constantUserType.Admin;
    },
    isDeveloper(state) {
      return state.user_type === constantUserType.Developer;
    },
    isUser(state) {
      return state.user_type === constantUserType.User;
    },
  },
  mutations: {
    setUserId(state, user_id) {
      state.user_id = user_id;
    },
    clearUserId(state) {
      state.user_id = '';
    },
    setUserType(state, user_type) {
      state.user_type = user_type;
    },
    setAdvertiserUserType(state, advertiser_type) {
      state.advertiser_type = advertiser_type;
    },
    clearUserType(state) {
      state.user_type = '';
    },
    setToken(state, token) {
      state.token = token;
    },
    clearToken(state) {
      state.token = '';
    },
  },
  actions: {
    async LOGIN({ commit }, userData) {
      const { data } = await loginUser(userData);
      commit('setToken', data.token);
      commit('setUserId', data.accountInfo.user_id);
      commit('setUserType', data.accountInfo.type);
      sessionStorage.setItem('token', JSON.stringify(data.token));
      sessionStorage.setItem(
        'user_id',
        JSON.stringify(data.accountInfo.user_id),
      );
      sessionStorage.setItem(
        'user_type',
        JSON.stringify(data.accountInfo.type),
      );
      if (data.accountInfo.type === 'user') {
        commit('setAdvertiserUserType', data.accountInfo.advertiser.type);
        sessionStorage.setItem(
          'advertiser_type',
          JSON.stringify(data.accountInfo.advertiser.type),
        );
      }
      return data;
    },
    async LOGOUT({ commit }) {
      const { data } = await logoutUser();
      commit('clearToken');
      commit('clearUserId');
      commit('clearUserType');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user_id');
      sessionStorage.removeItem('user_type');
      sessionStorage.removeItem('advertiser_type');
      return data;
    },
  },
});

store.initFromSession = function () {
  const token = JSON.parse(sessionStorage.getItem('token'));
  const user_id = JSON.parse(sessionStorage.getItem('user_id'));
  const user_type = JSON.parse(sessionStorage.getItem('user_type'));
  const advertiser_type = JSON.parse(sessionStorage.getItem('advertiser_type'));

  if (token) store.commit('setToken', token);
  if (user_id) store.commit('setUserId', user_id);
  if (user_type) store.commit('setUserType', user_type);
  if (advertiser_type) store.commit('setAdvertiserUserType', advertiser_type);
};

export default store;
